/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import React from 'react';
import { AppointmentAvailability } from '../../../../firebase/firestore/documents/appointmentAvaiability';
import { useStoreState } from '../../../../models/hooks';
import { CalendarSidebarTabTypeEnum, RecruiterCalendarSidebarTabTypeEnum } from '../../CalendarSidebarTab';

interface UseGetMeetingCountParams {
  checkedPositionsIds?: string[];
  activeTab?: CalendarSidebarTabTypeEnum | RecruiterCalendarSidebarTabTypeEnum;
}

export const useGetMeetingCount = ({ checkedPositionsIds, activeTab }: UseGetMeetingCountParams) => {
  const calendarPresenter = useStoreState((s) => s.calendar.calendarPresenter);

  return React.useCallback(
    (availability: AppointmentAvailability | undefined): number => {
      const meetingCount =
        activeTab !== CalendarSidebarTabTypeEnum.RECRUITERS
          ? calendarPresenter.listBookingByAppointmentIdAndPositionsId(availability?.id!, checkedPositionsIds).length
          : calendarPresenter.listBookingByAppointmentId(availability?.id!).length;

      return meetingCount;
    },
    [activeTab, checkedPositionsIds, calendarPresenter],
  );
};
